module.exports = __webpack_public_path__ + "static/media/av1.59e94dab.JPG";